




























import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import LazyImage from '@/components/Elements/LazyImage.vue'

@Component({
  components: {
    LazyImage
  }
})
export default class PDFTable extends Vue {

  @Prop({default: () => []}) PDFItems!: {
    id: number;
    locales: string[];
    pdf: string;
    productImage: string;
    title: string;
  }[];
  @Prop({default: false}) productImage!: object[];
  @Watch('$route', { immediate: true, deep: true })
  onUrlChange(route: {name: string}) {
    const { name } = route;
    this.currentPage = name;
  }

  multiColumnSortingEnabled = false;
  sortingPriority = [];
  currentPage = '';
  mobileCardBtn = true;
  showAvailableLocales = true;
  windowSize = {
    width: 0,
    height: 0
  }

  seperate(locales) {
    return locales.join(', ')
  }

  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  }

  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize() {
    this.windowSize.width = window.innerWidth;
    this.windowSize.height = window.innerHeight;

    switch (this.currentPage) {
      case 'manuals':
        this.mobileCardBtn = this.windowSize.width > 767;
        break;
      default:
        this.mobileCardBtn = true;
    }
  }

  getPDFItem(item) {
    this.$emit('getPDF', item);
  }

}
